/* Coverflow carousel for the "LP — Vlastnosti/Rady" section (card_style = image).
   Loaded once as an external asset so it survives theme-editor section reloads. */
(function () {
  if (window.__cfCoverflowInit) return;
  window.__cfCoverflowInit = true;

  function initCoverflow(el) {
    if (!el || el.dataset.cfInit === '1') return;
    var stage = el.querySelector('.cf-stage');
    if (!stage) return;
    var slides = Array.prototype.slice.call(stage.children).filter(function (s) {
      return s.classList && s.classList.contains('cf-slide');
    });
    var N = slides.length;
    if (!N) return;
    el.dataset.cfInit = '1';

    var active = 0;
    var suppressClick = false;

    // Optional per-instance overrides (data-cf-step, data-cf-max-offset) — default
    // to the original values so any carousel that doesn't set them (e.g. the
    // Riešenia rozcestník) keeps its exact existing behavior.
    var STEP = parseFloat(el.dataset.cfStep);
    if (!(STEP > 0)) STEP = 56;
    var MAX_OFFSET = parseInt(el.dataset.cfMaxOffset, 10);
    if (!(MAX_OFFSET >= 0)) MAX_OFFSET = 2;

    function offset(i) {
      var r = ((i - active) % N + N) % N;
      if (r > N / 2) r -= N;
      return r;
    }

    function layout() {
      var wrapped = [];
      for (var i = 0; i < N; i++) {
        var s = slides[i];
        var r = offset(i);
        var prev = (s._cfr == null) ? r : s._cfr;
        if (Math.abs(r - prev) > N / 2) { s.style.transition = 'none'; wrapped.push(s); }
        else { s.style.transition = ''; }

        var a = Math.abs(r);
        var sign = r < 0 ? -1 : 1;
        var tx = r * STEP;                        // % of card width per step (wider fan-out, still overlapping)
        var scale = Math.max(1 - a * 0.12, 0.7);
        var rot = -sign * Math.min(a, 2) * 6;     // deg
        // Cards stay fully opaque (no see-through); depth comes from scale + dimming.
        var bright = a === 0 ? 1 : (a === 1 ? 0.8 : 0.62);
        var visible = a <= MAX_OFFSET;

        s.style.transform = 'translateX(' + tx + '%) scale(' + scale + ') rotateY(' + rot + 'deg)';
        s.style.opacity = visible ? 1 : 0;
        s.style.filter = 'brightness(' + bright + ')';
        s.style.zIndex = 100 - a;
        s.style.pointerEvents = visible ? 'auto' : 'none';
        s.setAttribute('aria-hidden', a === 0 ? 'false' : 'true');
        s._cfr = r;
      }
      if (wrapped.length) {
        void stage.offsetWidth; // reflow so the teleport isn't animated
        requestAnimationFrame(function () { wrapped.forEach(function (s) { s.style.transition = ''; }); });
      }
    }

    function go(i) { active = ((i % N) + N) % N; layout(); }

    slides.forEach(function (s, i) {
      s.addEventListener('click', function (e) {
        if (suppressClick) { e.preventDefault(); return; }
        if (i === active) return;           // center card → let its link work
        e.preventDefault();                  // side card → bring to center
        go(i);
      });
    });

    var prev = el.querySelector('.cf-arrow--prev');
    var next = el.querySelector('.cf-arrow--next');
    if (prev) prev.addEventListener('click', function () { go(active - 1); });
    if (next) next.addEventListener('click', function () { go(active + 1); });

    var startX = null, dragging = false, moved = 0;
    stage.addEventListener('pointerdown', function (e) { startX = e.clientX; dragging = true; moved = 0; });
    window.addEventListener('pointermove', function (e) { if (dragging) moved = e.clientX - startX; });
    window.addEventListener('pointerup', function () {
      if (!dragging) return;
      dragging = false;
      if (Math.abs(moved) > 45) {
        suppressClick = true;
        setTimeout(function () { suppressClick = false; }, 60);
        go(active + (moved < 0 ? 1 : -1));
      }
    });
    window.addEventListener('resize', layout);

    requestAnimationFrame(layout);
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll('.cf-coverflow');
    for (var i = 0; i < nodes.length; i++) initCoverflow(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Re-init when the theme editor reloads a section
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
